import React from "react";
import style from "../../style/Pages/Help/ChatFeaturesHelp.module.css"; // or ChatFeaturesHelp.module.css if you prefer
import { Link } from "react-router-dom";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { TbArrowLeft } from "react-icons/tb";
import SecondaryLayout from "../../layouts/SecondaryLayout";

const ChatFeaturesHelp = () => {
  return (
    <>
      <SecondaryLayout>
        <div className={style.accountHelpWrapper}>
          <Link to="/help" className={style.backLink}>
            <TbArrowLeft className={style.backIcon} /> Back to Help Center
          </Link>

          <div className={style.header}>
            <IoChatbubbleEllipsesOutline className={style.headerIcon} />
            <h1>Chat Features</h1>
          </div>

          <div className={style.content}>
            <p>
              Our chat application is designed to provide a modern, smooth, and
              collaborative messaging experience. Here's what you can do in the
              chat interface:
            </p>

            <h2>📺 Channel Chat</h2>
            <ul>
              <li>
                Communicate within public or private channels created for
                different topics or teams.
              </li>
              <li>
                Admins can pin important messages and manage channel members.
              </li>
              <li>
                Channels offer threaded discussions to keep conversations
                organized.
              </li>
            </ul>

            <h2>👥 Group Chat</h2>
            <ul>
              <li>
                Create and join group chats for smaller teams or task-based
                discussions.
              </li>
              <li>
                Private by default, group chats allow file sharing and message
                reactions.
              </li>
              <li>
                Group members can mention each other and reply to specific
                messages.
              </li>
            </ul>

            <h2>🔍 Search & Discover</h2>
            <ul>
              <li>
                Use the global search bar to find specific messages, users, or
                files.
              </li>
              <li>
                Search by username to quickly connect with new or existing staff
                members.
              </li>
              <li>
                Advanced filters allow narrowing results by date, sender, or
                content type.
              </li>
            </ul>

            <h2>📎 File Sharing & Reactions</h2>
            <ul>
              <li>Upload images, documents, PDFs, and more within any chat.</li>
              <li>
                React to messages with emojis to express feedback instantly.
              </li>
            </ul>

            <p>
              Whether you're chatting with your team or searching for past
              conversations, our features help you stay efficient and connected.
            </p>
          </div>
        </div>
      </SecondaryLayout>
    </>
  );
};

export default ChatFeaturesHelp;
